<div class="row g-6 mb-6">
    <div class="col-xl-6">
        <app-missing-timesheets [missingTimesheets]="missingTimesheets"
            [missingTimesheetsCount]="missingTimesheetsCount"></app-missing-timesheets>
    </div>
    <div class="col-xl-6">
        <app-awaiting-approval-timesheets [awaitingApprovalTimesheets]="awaitingApprovalTimesheets"
            [awaitingApprovalTimesheetsCount]="awaitingApprovalTimesheetsCount"></app-awaiting-approval-timesheets>
    </div>
</div>